<template>
  <div>
    <div class="background_index_contact">
      <div class="index_contact_text">
        <p style="font-size: 22px;font-weight: bolder">联系我们</p>
        <p>上海市黄浦区湖滨路222号企业天地1705-11室</p>
        <p>邮编 200021</p>
        <p>电话：（+86）21-61222888</p>
        <p>邮箱：ChinaPIM@sig.com</p>
      </div>
      <div style="height: 18vh;padding-top: 6vh">
        <a-carousel autoplay :slides-to-show="6" :dots="false"
                    style="padding-top: 2vh;">
          <div v-for="(item, index) in logo.items" :key="index" style="display: flex;align-items: center;">
            <img :src="item" class="logo">
          </div>
        </a-carousel>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '../Footer'
import {reactive, onMounted} from 'vue'

export default {
  name: 'Index_contact',
  components: {
    Footer
  },
  setup() {
    const logo = reactive({
      items: [],
    })
    onMounted(() => {
          const files = require.context('../../../assets/logo').keys()
          for (let item of files) {
            logo.items.push(require('../../../assets/logo' + item.substring(1)))
          }
        }
    )
    return {logo,}
  }
}

</script>
<style scoped>
/*有跑马灯组件需要使用scoped-*/
.background_index_contact {
  background-image: url("../../../assets/background/index_contact.jpg");
  height: 80vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
  padding: 0 5vw;
}

.index_contact_text {
  text-align: left;
  padding-top: 24vh;
  padding-left: 8vw;
}

.index_contact_text p {
  font-size: 16px;
  margin-bottom: 0.5em;
}

.ant-carousel ::v-deep(.slick-slide) {
  text-align: center;
  height: 10vh;
  line-height: 10vh;
  overflow: hidden;
}

.ant-carousel ::v-deep(.slick-slide img) {
  width: 8vw;
  max-height: 5vh;
}

.logo {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
}


</style>